import React, { useEffect, useState } from "react";
import { Card, StyledBody, StyledAction } from "baseui/card";
import { Button } from "baseui/button";
import Check from "baseui/icon/check";
import { Block } from "baseui/block";
import {
  LabelMedium,
  ParagraphMedium,
  ParagraphSmall,
} from "baseui/typography";
import { styled, useStyletron } from "baseui";
import { createCheckoutSession, createCustomerPortalSession } from "../../helpers/PaymentHelpers";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { fetchOrgSubscription } from "../../redux/user/UserThunk";
// Dummy user plan for demonstration
const userPlan = "Free";
const MainContainer = styled("div", {
  display: "flex",
  flexDirection: "column",
  height: "100%",
  justifyContent: "space-between",
});
const PlansContainer  = styled("div", {
  display: "flex",
  flexDirection: "row",
  gap: "24px",
  height: "100%",
  maxWidth: "800px",
  margin: "auto",
});
const BottomLinkContainer = styled("div", {
  alignSelf: 'stretch', // Stretch to the full width of the container
  display: "flex",
  justifyContent: "start", // This will center the link horizontally
  padding: "20px 60px", // Add some padding at the top and bottom
});
const StyledCheckIcon = styled("div", {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: "36px",
  width: "36px",
});
// Add CSS for disabled state
const disabledStyle = {
  color: '#ccc',  // Grey out the link
  cursor: 'not-allowed',  // Show a not-allowed cursor
  pointerEvents: 'none',  // Disable pointer events
};
const PlanFeature = ({ children }) => (
  <Block display="flex" alignItems="center" marginBottom="scale300">
    <StyledCheckIcon>
      <Check size={36} disabled />
    </StyledCheckIcon>
    <ParagraphMedium marginLeft="scale200">{children}</ParagraphMedium>
  </Block>
);

const PlanCard = ({
  title,
  description,
  price,
  features,
  buttonText,
  displayButton,
  buttonDisabled,
  isLoading,
  onClick,
}) => {
  const [css, theme] = useStyletron();

  return (
    <Card
      overrides={{
        Root: {
          style: {
            flex: 1,
            display: "flex",
            flexDirection: "column",
            height: "100%",
            justifyContent: "space-between",
          },
        },
        Contents: {
          style: {
            display: "flex",
            flexDirection: "column",
            flexGrow: 1,
          },
        },
      }}
      title={title}
    >
      <StyledBody>
        <ParagraphSmall>{description}</ParagraphSmall>
        <LabelMedium className={css({ marginTop: theme.sizing.scale800, marginBottom: theme.sizing.scale800 })}>{price}</LabelMedium>
        <div className={css({ flex: "1", display: "flex", flexDirection: "column", justifyContent: "space-between" })}>
          {features.map((feature, index) => (
            <PlanFeature key={index}>{feature}</PlanFeature>
          ))}
        </div>
      </StyledBody>
      {displayButton && (
        <StyledAction>
          <Button
            onClick={onClick}
            disabled={buttonDisabled || isLoading}
            isLoading={isLoading}
            overrides={{ BaseButton: { style: { width: "100%" } } }}
          >
            {buttonText}
          </Button>
        </StyledAction>
      )}
    </Card>
  );
};

const UserAccountPlanView = (props) => {
  const isUserPremium = () =>  props.user?.subscription?.plan === "PREMIUM";
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation();
  useEffect(() => {
    props.fetchOrgSubscription(props.user.primaryOrgId);
  }, [props.user.userId]);
  const handleUpgradeClick = async () => {
    setIsLoading(true); // Start loading
    try {
      let res = await createCheckoutSession();
      if (res) {
        window.location.href = res;
      }
    } catch (error) {
      console.error("Failed to create checkout session:", error);
    } finally {
      setIsLoading(false); // Stop loading regardless of the outcome
    }
  };

  const handleManageSubscriptionClick = async () => {
    try {
      let res = await createCustomerPortalSession();
      if (res) {
        window.location.href = res;
      }
    }
    catch (error) {
      console.error("Failed to create customer portal session:", error);
    }    
  }


  return (
    <MainContainer>
      <PlansContainer>
      <PlanCard
        title={t("plans.free.title")}
        description={t("plans.free.description")}
        price={t("plans.free.price")}
        features={t("plans.free.features", { returnObjects: true })}
        displayButton={false}
        buttonDisabled={true}
      />
      <PlanCard
        title={t("plans.premium.title")}
        description={t("plans.premium.description")}
        price={t("plans.premium.price")}
        features={t("plans.premium.features", { returnObjects: true })}
        buttonText={t("plans.premium.buttonText")}
        displayButton={true}
        buttonDisabled={isUserPremium() }
        isLoading={isLoading}
        onClick={!isUserPremium() ? handleUpgradeClick : undefined}
      />
    
      </PlansContainer>
      <BottomLinkContainer>
        <Button
         $as="a" onClick={handleManageSubscriptionClick} kind="minimal"
         style={!isUserPremium() ? disabledStyle : {}}
         >
          {t("manageSubscriptions")}
        </Button>
      </BottomLinkContainer>        
    </MainContainer>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
    orgSubscription: state.user.subscription,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    fetchOrgSubscription: (user_id) => dispatch(fetchOrgSubscription(user_id)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(UserAccountPlanView);
